import { useEffect, useState } from "react"
import { O, SpinnerDiv } from "../../../../features/ui"
import { AddressForm } from "./addressForm"
import { Data2 } from "../../../data-types"
import { Localidad, Provincia } from "../../../../services/gob-ar"
import { useAddressLoaders } from "../../loaders/addressLoaders"

type Props = {
    addressData?: Data2
    onSubmit: (data: Data2) => void
    onCancel?: () => void
}

export const AddressFormLoader = (props: Props) => {
    const { addressData, onSubmit, onCancel } = props
    
    const [ready, setReady] = useState(false)
    const [provinces, setProvinces] = useState<Provincia[]>([])
    const [localities, setLocalities] = useState<Localidad[]>([])
    const [defaultProvince, setDefaultProvince] = useState<O<Provincia>>()
    const [defaultLocality, setDefaultLocality] = useState<O<Localidad>>()

    const addressLoaders = useAddressLoaders()

    const load = async () => {
        const { loadAllProvinces, loadAllLocalities } = addressLoaders()
        const loadedProvinces = await loadAllProvinces()
        setProvinces(loadedProvinces)
        const loadedLocalities = await loadAllLocalities()
        setLocalities(loadedLocalities)
        const defaultProvince = loadedProvinces.find(province => province.nombre === addressData?.province)
        setDefaultProvince(defaultProvince)
        const defaultLocality = loadedLocalities.find(locality => locality.nombre === addressData?.locality)
        setDefaultLocality(defaultLocality)
    }

    useEffect(() => {
        load().then(() => setReady(true))
    }, [])

    return ready ? (
        <AddressForm
            addressData={addressData}
            provinces={provinces}
            localities={localities}
            defaultProvince={defaultProvince}
            defaultLocality={defaultLocality}
            onSubmit={onSubmit}
            onCancel={onCancel}
        />
    ) : <SpinnerDiv />
}
